import { ApplicationState } from '../../store/rootReducer';
import { NormalizedListById } from '../../core';
import { AccommodationOfferFeeModel } from '../../api/interfaces';

export const getAccommodationOfferFees = (state: ApplicationState): NormalizedListById<AccommodationOfferFeeModel> => {
    return Object.assign({}, state.accommodationOfferCalculations.fees.byId);
};